export function arrowRightKey(event) {
  event.preventDefault()

  if (!this.selectedItem) return
  const { selectedItem } = this

  const { text, cursorPosition } = selectedItem.getParams()
  if (!text || cursorPosition === undefined) return

  const steps = text.slice(cursorPosition, cursorPosition + 2) === '/n' ? 2 : 1

  if (text.length <= cursorPosition) return

  selectedItem.setParams({
    text,
    cursorPosition: cursorPosition + steps,
  })
  this.engine.reRender()
}



// WEBPACK FOOTER //
// ./src/components/ScreenshotEditor/keyboardActions/arrowRightKey.js